module.exports = __webpack_public_path__ + "img/bannerImg.90db9d39.png";